
































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramColumns extends Vue {
  @Prop({ type: Array, default: () => [] }) columns!: any[];
  @Prop({ type: Number, default: 3 }) max!: number;
  @Prop({ type: Array, default: () => [] }) extras!: string[];

  open: boolean = false;

  get shown() {
    return this.open ? this.columns : this.columns.slice(0, this.max);
  }

  get moreLabel() {
    const rest = this.columns.length - this.max;
    return rest === 1
      ? this.$t("See the remaining one").toString()
      : this.$t("See the {0} remaining").toString().replace("{0}", String(rest));
  }
}
